"use client";

import clsx from "clsx";
import Link from "next/link";

import { buildLocalizedHref } from "~/app/lib/routeUtils";
import HomeIconSvg from "~/assets/images/helpCenter/home.svg";
import PricingOfferButton from "~/app/[locale]/pricing/components/PricingOfferButton";

import styles from "./HeroSectionNewActionButton.module.scss";

export default function HeroSectionNewActionButton({ locale, h1, subtitle, slug }) {


  return (
    <section className={styles.section} aria-labelledby="pseo-title">
      <div className="wrap">
        <nav aria-label="breadcrumb" className={styles.breadcrumbNav}>
          <ol>
            <li>
              <Link href={buildLocalizedHref(locale, "")} aria-label="Palmate">
                <HomeIconSvg className={styles.homeIcon} aria-hidden="true" />
              </Link>
            </li>
            <li>
              <span aria-current="page">{h1}</span>
            </li>
          </ol>
        </nav>
        <div className={styles.content}>
          <h1 id="pseo-title" className={styles.title} title={h1}>{h1}</h1>
          {subtitle && <p className={styles.desc}>{subtitle}</p>}
          <div className={styles.buttonWrapper}>
            <PricingOfferButton className={clsx("pill", styles.ctaButton)} source={`solutions-${slug}`} />
          </div>
        </div>
      </div>
    </section>
  );
}
